import { Modal } from '@/components/common/Modal'
import { Button } from '@/components/common/Button'
import { CheckCircle2 } from 'lucide-react'

interface TokenMatch {
  token: string
  field: string
  confidence: number
}

interface OKDialogProps {
  isOpen: boolean
  matchedCount: number
  matchedTokens: TokenMatch[]
  onPreview: () => void
  onImport: () => void
  onClose: () => void
}

export function TokenOKDialog({ isOpen, matchedCount, matchedTokens, onPreview, onImport, onClose }: OKDialogProps) {
  const fieldBreakdown = matchedTokens.reduce<Record<string, number>>((acc, t) => {
    acc[t.field] = (acc[t.field] || 0) + 1
    return acc
  }, {})

  const fieldLabels: Record<string, string> = {
    teacher_code: 'Lehrer-Code',
    teacher_name: 'Lehrer-Name',
    subject: 'Fach',
    room: 'Raum',
    class_name: 'Klasse',
    time_slot: 'Zeit',
    ignore: 'Ignoriert',
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Alle Token zugeordnet" size="md">
      <div className="space-y-4">
        <div className="flex items-center gap-2 text-green-600">
          <CheckCircle2 className="h-5 w-5" />
          <span className="font-medium">Alle {matchedCount} Token wurden automatisch korrekt zugeordnet.</span>
        </div>

        <div>
          <h4 className="font-medium mb-2 text-sm text-gray-700">Übersicht nach Feldtyp:</h4>
          <div className="space-y-1">
            {Object.entries(fieldBreakdown)
              .sort((a, b) => b[1] - a[1])
              .map(([field, count]) => (
                <div key={field} className="flex justify-between text-sm">
                  <span className="text-gray-600">{fieldLabels[field] || field}</span>
                  <span className="font-medium">{count}</span>
                </div>
              ))}
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="secondary" size="sm" onClick={onClose}>
            Schliessen
          </Button>
          <Button variant="secondary" size="sm" onClick={onPreview}>
            Einträge prüfen
          </Button>
          <Button size="sm" onClick={onImport}>
            Weiter zum Import
          </Button>
        </div>
      </div>
    </Modal>
  )
}
